import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onRefreshPersonInfo = action('onRefreshPersonInfo', event => ({
    event,
    owaType: 'refreshPersonInfo',
})) as OwaNovaActionUnion<'refreshPersonInfo'>;
